import React from "react";

import { Link } from "react-router-dom";
export default function Meal({ id, image, name, cate, area, info }) {
  return (
    <>
        <div className="flex m-auto mb-10 shadow-lg shadow-green-500 w-full h-full bg-white rounded"> 
        <div className="w-1/3">
            <img className="w-full h-full object-cover rounded rounded-r-none" 
            src={image} 
            alt={name} />
        </div>
        <div className="w-2/3 p-5 relative">
            <h3 className="text-2xl text-purple-700 font-semibold ">{name}</h3>
            <p className="my-3 text-gray-700 ">
                {info && info.substring(0,500)+'...'}
            </p>
            <ul className="flex">
                <li className="mr-8">
                    <span className="text-grey-700">Category</span>
                    <strong className="block text-purple-700">{cate}</strong>
                </li>
                <li>
                    <span className="text-grey-700">Area</span>
                    <strong className="block text-purple-700">{area} </strong>
                </li>
            </ul>
            <Link to={`/meal/${id}`} className="bg-orange-400 text-white rounded shadow px-3 py-2 absolute bottom-0 right-0 -mr-2">
                    Details <i className="fas fa-arrow-alt-circle-right"></i>
            </Link>
        </div>
      </div> 
    </>
   
  );
}

